import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';
import { LineBreakPipe } from '../../../pipes/line-break.pipe';

@Component({
  selector: 'app-carousel',
  imports: [CommonModule, CarouselModule, LineBreakPipe],
  templateUrl: './carousel.component.html',
})
export class CarouselComponent implements OnChanges {
  // @Input({ required: true }) content!: ProductDesignTemplatePageContent;
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;

  items: ProductDesignTemplatePageModuleDataContent[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }
}
